import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';
import productBOM from '@Components/Inventory/ManageProducts/ViewProduct/ProductBOMList/ProductBOM';
import productionRoutesLines
from '@Components/Production/ManufacturingOrders/ViewManufacturingOrder/Tables/ProductionRoutesLines';

/**
 */
class JobWorkServices {
    /**
   * @param {*} orgId
   * @param {*} tenantId
   * @param {*} departmentId
   * @param {*} status
   * @param {*} moStatus
   * @param {*} route
   * @param {*} searchKeyword
   * @param {*} page
   * @param {*} limit
   * @param {*} resourceId
   * @return
   */
    getJobWorks = async (orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen) => {
      let url = `${Constants.JOB_WORK}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (tenantId) url += `tenant_id=${tenantId}&`;
      if (departmentId) url += `department_id=${departmentId}&`;
      if (status) url += `status=${status}&`;
      if (moStatus) url += `mo_status=${moStatus}&`;
      if (page) url += `page=${page}&`;
      if (route) url += `route=${route}`;
      if (limit) url += `limit=${limit}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (assignee) url += `user_id=${assignee}&`;
      if (resourceId) url += `resource_id=${resourceId}&`;
      if (resourceGroupId) url += `resource_group_id=${resourceGroupId}&`;
      if (isListScreen) url += `list_screen=${isListScreen}&`;
      const jobWorks = await Helpers.get({ url });
      return jobWorks;
    }

    getJobWorksV2 = async (orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen) => {
      let url = `${Constants.JOB_WORK_V2}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (tenantId) url += `tenant_id=${tenantId}&`;
      if (departmentId) url += `department_id=${departmentId}&`;
      if (status) url += `status=${status}&`;
      if (moStatus) url += `mo_status=${moStatus}&`;
      if (page) url += `page=${page}&`;
      if (route) url += `route=${route}`;
      if (limit) url += `limit=${limit}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (assignee) url += `assignee_user_id=${assignee}&`;
      if (resourceId) url += `resource_id=${resourceId}&`;
      if (resourceGroupId) url += `resource_group_id=${resourceGroupId}&`;
      if (sellerId) url += `subcontractor_seller_id=${sellerId}&`;
      if (isListScreen) url += `list_screen=${isListScreen}&`;
      const jobWorks = await Helpers.get({ url });
      return jobWorks;
    }

    /**
     *
     * @param tenantId
     * @param productionRoutesLineId
     * @returns {Promise<*>}
     */
    getJobWorkById = async (tenantId, productionRoutesLineId) => {
      let url = `${Constants.JOB_WORK}?`;
      if (tenantId) url += `tenant_id=${tenantId}&`;
      if (productionRoutesLineId) url += `prl_id=${productionRoutesLineId}&`;
      const jobWork = await Helpers.get({ url });
      return jobWork;
    }

    getJobWorkByIdV2 = async (tenantId, productionRoutesLineId) => {
      let url = `${Constants.JOB_WORK_V2}?`;
      if (tenantId) url += `tenant_id=${tenantId}&`;
      if (productionRoutesLineId) url += `prl_id=${productionRoutesLineId}&`;
      const jobWork = await Helpers.get({ url });
      return jobWork;
    }

    /**
   * @param {*} orgId
   * @param {*} tenantId
   * @param {*} moId
   * @return
   */
     getJobWorkByMoId = async (orgId, tenantId, moId, isListScreen) => {
       let url = `${Constants.JOB_WORK}?`;
       if (orgId) url += `org_id=${orgId}&`;
       if (tenantId) url += `tenant_ids=${tenantId}&`;
       if (moId) url += `mo_id=${moId}&`;
       if (isListScreen) url += `list_screen=${isListScreen}&`;

       const jobWorks = await Helpers.get({ url });

       return jobWorks;
     }

     getJobWorkByMoIdV2 = async (orgId, tenantId, moId, isListScreen) => {
      let url = `${Constants.JOB_WORK_V2}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (tenantId) url += `tenant_ids=${tenantId}&`;
      if (moId) url += `mo_id=${moId}&`;
      if (isListScreen) url += `list_screen=${isListScreen}&`;

      const jobWorks = await Helpers.get({ url });

      return jobWorks;
    }

    /**
     *
     * @param payload
     * @returns {Promise<*>}
     */
    updateJobWork = async (payload) => {
      const jobWorks = await Helpers.put({
        url: Constants.UPDATE_JOB_WORK,
        data: payload,
      });
      return jobWorks;
    }

    updateJobWorkV2 = async (payload) => {
      const jobWorks = await Helpers.put({
        url: Constants.UPDATE_JOB_WORK_V2,
        data: payload,
      });
      return jobWorks;
    }

    /**
     *
     * @param orgId
     * @returns {Promise<*>}
     */
    getJobOperators = async (orgId) => {
      const jobOperators = await Helpers.get({
        url: `${Constants.GET_JOB_OPERATORS}?org_id=${orgId}`,
      });
      return jobOperators;
    }

    /**
     *
     * @param groupBy
     * @param tenantIds
     * @param orgId
     * @param status
     * @param page
     * @param limit
     * @param userIds
     * @returns {Promise<*>}
     */
    getKanbanJobWorks = async (groupBy, tenantIds, orgId, status, page, limit, userIds, startDate, endDate, departmentId, searchKeyword, moStatus, resourceId, resourceGroupId) => {
      let subUrl = '';
      if (groupBy === 'machine') subUrl = 'jw_group_by_resource';
      if (groupBy === 'work_center') subUrl = 'jw_group_by_resource_group';
      if (groupBy === 'operator') subUrl = 'jw_group_by_assignee';
      let url = `${Constants.ROUTING_PROCESS}/${subUrl}?`;
      if (tenantIds) url += `tenant_id=${tenantIds}&`;
      if (orgId) url += `org_id=${orgId}&`;
      if (status) url += `status=${status}&`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      if (userIds) url += `user_id=${userIds}&`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `to_date=${endDate}&`;
      if (departmentId) url += `department_id=${departmentId}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
      if (moStatus) url += `mo_status=${moStatus}&`;
      if (resourceId) url += `resource_id=${resourceId}&`;
      if (resourceGroupId) url += `resource_group_id=${resourceGroupId}&`;
      const jobWorks = await Helpers.get({
        url,
      });
      return jobWorks;
    }

    processJwMaterial = async (payload) => {
      const jobWorks = await Helpers.post({
        url: Constants.PROCESS_JW_MATERIAL,
        data: payload,
      });
      return jobWorks;
    }

    processJwMaterialComplete = async (payload) => {
      const jobWorks = await Helpers.put({
        url: Constants.PROCESS_JW_MATERIAL,
        data: payload,
      });
      return jobWorks;
    }
}
export default new JobWorkServices();
